export default __webpack_public_path__ + "static/media/logo-círculo.ef89376a.svg";